import React from "react";
import { Box, Typography } from "@mui/material";
// Removed Accordion imports as requested

const RdsConfiguration = ({
  formConfig,
  formData,
  setFormData,
  formSubmitted,
  apiValidationFields,
  setApiValidationFields,
  disabledFields,
  renderField,
}) => {
  const configFields = formConfig.filter(
    (field) => field.tabName === "Configuration" && field.isDisplay
  );

  const subTabs = [...new Set(configFields.map((f) => f.subTab).filter(Boolean))];

  return (
    <Box sx={{ width: "100%", mt: 2 }}>
      {subTabs.map((subTabName, index) => {
        const subTabFields = configFields.filter((f) => f.subTab === subTabName);

        return (
          <Box key={subTabName || index} sx={{ mb: 4 }}>
            {/* Standard Heading replacing the AccordionSummary */}
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "16px", mb: 2, color: "#000" }}>
              {subTabName}
            </Typography>
            
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                width: "100%",
              }}
            >
              {subTabFields.map((field) => {
                const rendered = renderField(field);
                if (!rendered) return null;

                // Check if the field is the username field. 
                // Note: Update "masterUsername" if your exact JSON fieldName differs.
                const isUsernameField = field.fieldName === "masterUsername" || field.fieldName === "MasterUsername";

                return (
                  <Box
                    key={field.fieldId}
                    sx={{
                      // Force Username to take the full line so passwords align together on the next line
                      flex: isUsernameField ? "1 1 100%" : "1 1 calc(50% - 16px)",
                      minWidth: "280px",
                    }}
                  >
                    {rendered}
                  </Box>
                );
              })}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default RdsConfiguration;